import AllOrders from './AllOrders';

export default AllOrders;
